export default __webpack_public_path__ + "static/media/semicolon.a9c1d597.svg";